import cx from 'classnames';
import { useTranslation } from 'react-i18next';

import { useWebThemeContext } from '~/components/Layout/Context/useWebThemeContext';

interface Props {
  isSubmitting: boolean;
  fontFamily: string;
  ctaText: string;
  fontSize?: 'sm' | 'lg';
  backgroundColor?: string;
  borderColor?: string;
  textColor?: string;
  className?: string;
  shouldAdjustRadius?: boolean;
}

const adjustedRadius = (radiusClass: string) => {
  switch (radiusClass) {
    case 'rounded-none':
      return 'rounded-none';
    case 'rounded-sm':
      return 'rounded-xs';
    case 'rounded-md':
      return 'rounded-sm';
    case 'rounded-lg':
      return 'rounded-md';
    case 'rounded-xl':
      return 'rounded-lg';
    case 'rounded-2xl':
      return 'rounded-xl';
    case 'rounded-3xl':
      return 'rounded-2xl';

    default:
      return 'rounded-none';
  }
};

const SubmitButton = ({
  isSubmitting,
  ctaText,
  backgroundColor,
  fontFamily,
  fontSize,
  textColor,
  className,
  borderColor,
  shouldAdjustRadius = false,
}: Props) => {
  const { t } = useTranslation();
  const { classes } = useWebThemeContext();
  const cta = ctaText || t('shared.cta.subscribe');

  return (
    <input
      type="submit"
      value={isSubmitting ? `${t('shared.actions.submitting')}...` : cta}
      style={{
        ...(backgroundColor && { backgroundColor: backgroundColor }),
        ...(textColor && { color: textColor }),
        ...(fontFamily && { fontFamily: fontFamily }),
        ...(borderColor && { borderColor: borderColor }),
      }}
      className={cx(
        'cursor-pointer px-5 py-3 font-semibold',
        'w-full sm:w-auto',
        {
          'text-lg focus:text-lg active:text-lg sm:text-lg': !fontSize || fontSize === 'lg',
        },
        { 'text-sm focus:text-sm active:text-sm': fontSize === 'sm' },
        shouldAdjustRadius ? classes.radius : adjustedRadius(classes.radius),
        className,
      )}
      disabled={isSubmitting}
    />
  );
};

export default SubmitButton;
